// extracted by mini-css-extract-plugin
module.exports = {"widgetsWrapperOuter":"Marketometer_widgetsWrapperOuter__2WLMk","speedometer":"Marketometer_speedometer__3JJuz","table":"Marketometer_table__3qOZZ"};